import { useContext } from "react";
import { CacheContext } from "../contexts/CacheContext";

export function useCache() {
  return useContext(CacheContext);
}